import { Component } from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import { getString } from '../../locale'

type Props = {
    value: string
    onChange?: (value: string) => void
    placeholder?: string
    className?: string
}

type State = {
    visible: boolean
}

/** Password input with a show/hide (eye) toggle. Used on the WiFi pages. */
class PasswordInput extends Component<Props, State> {
    state: State = { visible: false }

    render() {
        const { value, onChange, placeholder, className } = this.props
        const { visible } = this.state
        return (
            <div className="relative">
                <input
                    type={visible ? 'text' : 'password'}
                    className={className}
                    // Passwords are LTR content; keep the toggle on the physical right edge.
                    // (Inline styles: Tailwind 2 needs the `transform` class for translate utilities,
                    // and logical properties would flip to the left in the RTL page direction.)
                    dir="ltr"
                    style={{ paddingRight: '2.5rem' }}
                    value={value}
                    onChange={e => onChange?.(e.target.value)}
                    placeholder={placeholder}
                />
                <button
                    type="button"
                    onClick={() => this.setState({ visible: !visible })}
                    title={visible ? getString('common.hide_password') : getString('common.show_password')}
                    aria-label={visible ? getString('common.hide_password') : getString('common.show_password')}
                    className="absolute p-1 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 focus:outline-none"
                    style={{ right: '0.5rem', top: '50%', transform: 'translateY(-50%)' }}
                >
                    {visible ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
            </div>
        )
    }
}

export default PasswordInput
